const environment = process.env.REACT_APP_ENVIRONMENT
const isProduction = environment === 'production'

const productionApiUrl = process.env.REACT_APP_BASEURL
const developmentApiUrl = process.env.REACT_APP_BASEURL_DEV

const productionFrontUrl = process.env.REACT_APP_FRONT_URL
const developmentFrontUrl = process.env.REACT_APP_FRONT_URL_DEV

const BASE_URL = isProduction ? productionApiUrl : developmentApiUrl
const FRONT_URL = isProduction ? productionFrontUrl : developmentFrontUrl

export const URLs = {
  BASE_URL,
  FRONT_URL,
}
